import { Axios } from 'utils/AxiosConfig'

export const getAccountInformation = async (token = null) => {
  if (token) {
    const { data: response } = await Axios.get(`member/profile/account-information`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    return response
  } else {
    const { data: response } = await Axios.get(`member/profile/account-information`)
    return response
  }
}
export const postUpdateProfile = async (payload) => {
  const { data: response } = await Axios.put(`member/profile/account-information`, payload)
  return response
}

export const postUpdatePassword = async (payload) => {
  const { data: response } = await Axios.put(`member/profile/password`, payload)
  return response
}
export const getAdvisorCompany = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/advisor/company-for-sale`, payload)
  return response
}
export const getUserCompany = async (payload) => {
  const { data: response } = await Axios.get(`member/profile/company-for-sale`, payload)
  return response
}
export const putPostedStatusSellCompany = async (payload) => {
  const { data: response } = await Axios.put(
    `member/profile/company-for-sale/is-posted-flag/${payload.id}`,
    payload.params
  )
  return response
}
export const getUserPackageList = async (payload) => {
  const { data: response } = await Axios.get(
    `member/package-subscription/paid-package/${payload.roleType}`,
    { params: payload.params }
  )
  return response
}
export const getProfileAdvisor = async () => {
  const { data: response } = await Axios.get(`member/profile/advisor`)
  return response
}
export const getUserActivePackages = async () => {
  const { data: response } = await Axios.get(`member/package-subscription/active-packages`)
  return response
}
export const deleteSellerProfile = async (id) => {
  const { data: response } = await Axios.delete(`member/profile/advisor/company-for-sale/${id}`)
  return response
}
export const deleteSellerProfileBySeller = async (id) => {
  const { data: response } = await Axios.delete(`member/package-subscription/seller/${id}`)
  return response
}
export const getNDASender = async () => {
  const { data: response } = await Axios.get(`member/nda-deal/sender`)
  return response
}
export const getNDAReceiver = async (user_contact_request_id) => {
  const { data: response } = await Axios.get(`member/nda-deal/receiver/${user_contact_request_id}`)
  return response
}